import { useQuery } from '@tanstack/react-query';

import { fetchMe } from '../api/auth.js';
import { useBrandingStore } from '../stores/branding-store.js';

/**
 * Phase 10 — convenience hook that returns `{ userId, orgSlug }` for
 * offline-aware mutations. Both values must exist before the runner
 * can enqueue anything (we tag every queue row with userId so logout
 * can wipe a specific tenant's data).
 */
export function useOfflineContext(): { userId: string | null; orgSlug: string | null } {
  const me = useQuery({ queryKey: ['me'], queryFn: fetchMe, staleTime: 60_000 });
  const orgSlug = useBrandingStore((s) => s.snapshot?.orgSlug ?? null);
  return { userId: me.data?.user.id ?? null, orgSlug };
}
